<template>
  <AppCard
    elevation="0"
    data-locator="subscription-consumption-support"
  >
    <h3 class="mb-3 text--medium font-weight-bold text-text-primary">
      {{ $t(`${TRANSLATION_KEY_PREFIX}.title`) }}
    </h3>
    <p class="mb-8 text--small text-text-secondary">
      {{ $t(`${TRANSLATION_KEY_PREFIX}.description`) }}
    </p>

    <div class="d-flex flex-column row-gap-2">
      <a
        class="SubscriptionConsumptionSupport__item text--x-small text-text-tertiary"
        :href="`tel:${phoneHref}`"
        data-locator="subscription-consumption-support-phone"
      >
        <app-material-icon name="call" :size="16" color="inherit" class="mr-1"/>
        <span>{{ phoneDisplay }}</span>
      </a>

      <a
        class="SubscriptionConsumptionSupport__item text--x-small text-text-tertiary"
        :href="`mailto:${supportEmail}`"
        data-locator="subscription-consumption-support-email"
      >
        <app-material-icon name="mail" :size="16" color="inherit" class="mr-1"/>
        <span>{{ supportEmail }}</span>
      </a>

      <div
        class="SubscriptionConsumptionSupport__item text--x-small text-text-tertiary"
        data-locator="subscription-consumption-support-chat"
      >
        <app-material-icon name="forum" :size="16" color="inherit" class="mr-1"/>
        <span>{{ $t(`${TRANSLATION_KEY_PREFIX}.chat`) }}</span>
      </div>
    </div>
  </AppCard>
</template>

<script>
  import AppCard from '@/common/AppCard.vue'
  import {
    SALES_PHONE_NUMBER_DISPLAY,
    SALES_PHONE_NUMBER_WITH_COUNTRY_CODE,
    SUPPORT_EMAIL_ADDRESS,
  } from '@/common/utils/closdInfo'

  const TRANSLATION_KEY_PREFIX = 'subscriptions.views.SubscriptionConsumption.Support'

  export default {
    name: 'SubscriptionConsumptionSupport',
    components: { AppCard },
    data () {
      return {
        TRANSLATION_KEY_PREFIX,
        phoneDisplay: SALES_PHONE_NUMBER_DISPLAY,
        phoneHref: SALES_PHONE_NUMBER_WITH_COUNTRY_CODE,
        supportEmail: SUPPORT_EMAIL_ADDRESS,
      }
    },
  }
</script>

<style scoped lang="scss">
  .SubscriptionConsumptionSupport__item {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: inherit;
  }
</style>
